const violet100Color = '#DDE1EE';

export default violet100Color;
